export const  profile = {
  "Title": "Your Profile",
  "LogInInformation": "Login Information",
  "UserID": "User ID",
  "Password": "Password",
  "YourName": "Your Name",
  "ChangeYourPassword": "Change Your Password",
  "OldPassword": "Current Password",
  "NewPassword": "New Password",
  "ConfirmPassword": "Confirm Password",
  "ChangeYourName": "Change Your Name",
  "FirstName": "First Name",
  "LastName": "Last Name",
  "YourFirstName": "Your First Name",
  "YourLastName": "Your Last Name",
  "modifyPasswordSuccess": "Your password has been modified successfully. Please log in with your new password."
}